import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../Reveal";
import { SolutionDialog } from "../SolutionDialog";
import { useLang } from "../../i18n/LanguageContext";
import { solutionCategories } from "../../content/solutions";

export const SolutionsPortfolio = () => {
  const { t, path } = useLang();
  const [active, setActive] = useState(null);

  return (
    <section className="bg-[#F7F8F5] py-28 md:py-36" data-testid="home-solutions">
      <div className="max-w-[1320px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <Reveal>
            <p className="eyebrow-dark">{t.solutions.eyebrow}</p>
            <h2 className="mt-5 text-3xl md:text-4xl font-light tracking-tight text-[#061A26] max-w-lg">
              {t.solutions.title}
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <Link to={path("/solutions")} className="link-accent" data-testid="solutions-view-all-link">
              {t.solutions.viewAll}
              <ArrowUpRight size={15} />
            </Link>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {solutionCategories.map((s, i) => {
            const data = t.solutionsData[s.id];
            return (
            <Reveal key={s.id} delay={(i % 3) * 0.1} y={22}>
              <button
                onClick={() => setActive(s)}
                data-testid={`solution-card-${s.id}`}
                className="group w-full text-left bg-white border border-black/5 overflow-hidden hover:border-[#19C7C1]/40 transition-colors duration-500 hover:-translate-y-1 transition-transform"
              >
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={s.image}
                    alt={data.name}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                  />
                  <span className="absolute top-4 left-4 text-[10px] tracking-[0.15em] uppercase bg-[#061A26]/70 backdrop-blur-sm text-white/90 px-3 py-1.5">
                    {t.solutions.demoBadge}
                  </span>
                </div>
                <div className="p-7 flex items-start justify-between gap-4">
                  <div>
                    <h3 className="text-base md:text-lg font-semibold text-[#061A26]">{data.name}</h3>
                    <p className="mt-2 text-sm text-slate-600 leading-relaxed line-clamp-2">{data.desc}</p>
                  </div>
                  <ArrowUpRight size={18} className="shrink-0 mt-1 text-slate-400 group-hover:text-[#19C7C1] transition-colors duration-300" />
                </div>
              </button>
            </Reveal>
            );
          })}
        </div>
      </div>
      <SolutionDialog solution={active} onClose={() => setActive(null)} />
    </section>
  );
};
